const Remove = () => (
  <>
    <path
      fill="currentColor"
      d="M6.5 12.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.213.144-.356A.49.49 0 0 1 6.5 11.5h11q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143z"
    />
  </>
)
export default Remove
